import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formera';

const MyField = ({ label, ...rest }) => (
  <Field
    {...rest}
    render={({ input, meta: { error, touched } }) => {

      let inputClass = 'form-control input-md';

      if (input.type === 'checkbox')
      {
        inputClass = '';
      }

      return (

      <div className="form-group">
        <label className="control-label">{label}</label>
        <div>
          <input className={inputClass} {...input} />
          {error && touched && <div style={{ color: 'red' }}>{error}</div>}
        </div>
      </div>

    )}}
  />
);

export default MyField;



// WEBPACK FOOTER //
// ./src/components/Summary/components/MyField.js